//React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import CashbackComponent from "../../components/product/cashback/cashbackComponent";

export default function CashbackProductPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <NavBarComponent />
                <CashbackComponent />
                <FooterComponent />
            </div>
        </div>
    );
}

